export function caseThen(cases: [string, string, string?][]) {
  return (
    cases.reduce((query, [testValue, value]) => {
      return query + ` WHEN ${testValue} THEN ${value}`;
    }, 'CASE') + ' END'
  );
}
